import { APP_TYPE } from '@/src/general/enums/appTypes'
import { getAppType } from '@/src/general/utils/getAppType'

type TNavigatorWithRelatedApps = Navigator & {
  getInstalledRelatedApps?: () => Promise<unknown[]>
}

/**
 * Best-effort detection of the Hozana native app from the browser.
 *
 * Only Chromium on Android exposes `getInstalledRelatedApps` (backed by `related_applications` in the web manifest),
 * there is no way to detect it from Safari on iOS.
 */
export const getIsNativeAppInstalled = async (): Promise<boolean> => {
  const appType = getAppType()
  if (appType === APP_TYPE.IOS_NATIVE || appType === APP_TYPE.ANDROID_NATIVE) return true

  const { getInstalledRelatedApps } = navigator as TNavigatorWithRelatedApps
  if (typeof getInstalledRelatedApps !== 'function') return false

  try {
    const relatedApps = await getInstalledRelatedApps.call(navigator)
    return relatedApps.length > 0
  } catch {
    return false
  }
}
